import AuthModal from "@/components/views/modals/auth/AuthModal";
import { useSideBarAuthModal } from "@/hooks/useSideBarAuthModal";

export default function SidebarAuthModal() {
  const { openedModal, setOpenedModal } = useSideBarAuthModal();

  return (
    <>
      <AuthModal
        initialModal="login"
        isOpened={openedModal == "login"}
        closer={() => {
          setOpenedModal(null);
        }}
      />

      <AuthModal
        initialModal="signup"
        isOpened={openedModal == "register"}
        closer={() => {
          setOpenedModal(null);
        }}
      />
    </>
  );
}
